<template>
    <div> 
        <div class="container" style="margin-top:-20px">  
            <ul>
                <li class="icon-li" v-for="(item,index) in list" :key="index">
                    <div class="icon-li-content"  @click="copyLink(item)">
                        <i :class="`el-icon-lx-${item}`" style="font-size:22px;"></i>
                        <span>{{item}}</span>
                    </div>
                </li>
            </ul>
            <ul>
                <li class="icon-li" v-for="(item,index) in list2" :key="index">
                    <div class="icon-li-content" @click="copyLink2(item)">
                        <i style="font-size:22px;" :class="`el-icon-${item}`"></i>
                        <el-link style="font-size:12px;"> {{item}}</el-link>
                    </div>
                </li> 
            </ul>
            <h2>菜单中使用</h2>
             
            <p class="example-p">
                 
                <span>点击图标名称即可</span>
            </p>
            
            <br> 

            <h2>代码中使用</h2>
            <p style="line-height: 50px;">
                直接通过设置类名为 el-icon-lx-iconName 来使用即可。例如：（共{{iconList.length}}个图标）
            </p>
            <p class="example-p">
                <i class="el-icon-lx-redpacket_fill" style="font-size: 30px;color: #ff5900"></i>
                <span>&lt;i class=&quot;el-icon-lx-redpacket_fill&quot;&gt;&lt;/i&gt;</span>
            </p>
            <p class="example-p">
                <i class="el-icon-lx-weibo" style="font-size: 30px;color:#fd5656"></i>
                <span>&lt;i class=&quot;el-icon-lx-weibo&quot;&gt;&lt;/i&gt;</span>
            </p>
            <p class="example-p">
                <i class="el-icon-lx-emojifill" style="font-size: 30px;color: #ffc300"></i>
                <span>&lt;i class=&quot;el-icon-lx-emojifill&quot;&gt;&lt;/i&gt;</span>
            </p>
            <br>
        </div>
        

    </div>
</template>

<script>
import bus from '../common/bus';  
    export default {
        data: function(){
            return {
                keyword: '',
                iconList2: [
                    'platform-eleme',
'eleme',
'delete-solid',
'delete',
's-tools',
'setting',
'user-solid',
'user',
'phone',
'phone-outline',
'more',
'more-outline',
'star-on',
'star-off',
's-goods',
'goods',
'warning',
'warning-outline',
'question',
'info',
'remove',
'circle-plus',
'success',
'error',
'zoom-in',
'zoom-out',
'remove-outline',
'circle-plus-outline',
'circle-check',
'circle-close',
's-help',
'help',
'minus',
'plus',
'check',
'close',
'picture',
'picture-outline',
'picture-outline-round',
'upload',
'upload2',
'download',
'camera-solid',
'camera',
'video-camera-solid',
'video-camera',
'message-solid',
'bell',
's-cooperation',
's-order',
's-platform',
's-fold',
's-unfold',
's-operation',
's-promotion',
's-home',
's-release',
's-ticket',
's-management',
's-open',
's-shop',
's-marketing',
's-flag',
's-comment',
's-finance',
's-claim',
's-custom',
's-opportunity',
's-data',
's-check',
's-grid',
'menu',
'share',
'd-caret',
'caret-left',
'caret-right',
'caret-bottom',
'caret-top',
'bottom-left',
'bottom-right',
'back',
'right',
'bottom',
'top',
'top-left',
'top-right',
'arrow-left',
'arrow-right',
'arrow-down',
'arrow-up',
'd-arrow-left',
'd-arrow-right',
'video-pause',
'video-play',
'refresh',
'refresh-right',
'refresh-left',
'finished',
'sort',
'sort-up',
'sort-down',
'rank',
'loading',
'view',
'c-scale-to-original',
'date',
'edit',
'edit-outline',
'folder',
'folder-opened',
'folder-add',
'folder-remove',
'folder-delete',
'folder-checked',
'tickets',
'document-remove',
'document-delete',
'document-copy',
'document-checked',
'document',
'document-add',
'printer',
'paperclip',
'takeaway-box',
'search',
'monitor',
'attract',
'mobile',
'scissors',
'umbrella',
'headset',
'brush',
'mouse',
'coordinate',
'magic-stick',
'reading',
'data-line',
'data-board',
'pie-chart',
'data-analysis',
'collection-tag',
'film',
'suitcase',
'suitcase-1',
'receiving',
'collection',
'files',
'notebook-1',
'notebook-2',
'toilet-paper',
'office-building',
'school',
'table-lamp',
'house',
'no-smoking',
'smoking',
'shopping-cart-full',
'shopping-cart-1',
'shopping-cart-2',
'shopping-bag-1',
'shopping-bag-2',
'sold-out',
'sell',
'present',
'box',
'bank-card',
'money',
'coin',
'wallet',
'discount',
'price-tag',
'news',
'guide',
'male',
'female',
'thumb',
'cpu',
'link',
'connection',
'open',
'turn-off',
'set-up',
'chat-round',
'chat-line-round',
'chat-square',
'chat-dot-round',
'chat-dot-square',
'chat-line-square',
'message',
'postcard',
'position',
'turn-off-microphone',
'microphone',
'close-notification',
'bangzhu',
'time',
'odometer',
'crop',
'aim',
'switch-button',
'full-screen',
'copy-document',
'mic',
'stopwatch',
'medal-1',
'medal',
'trophy',
'trophy-1',
'first-aid-kit',
'discover',
'place',
'location',
'location-outline',
'location-information',
'add-location',
'delete-location',
'map-location',
'alarm-clock',
'timer',
'watch-1',
'watch',
'lock',
'unlock',
'key',
'service',
'mobile-phone',
'bicycle',
'truck',
'ship',
'basketball',
'football',
'soccer',
'baseball',
'wind-power',
'light-rain',
'lightning',
'heavy-rain',
'sunrise',
'sunrise-1',
'sunset',
'sunny',
'cloudy',
'partly-cloudy',
'cloudy-and-sunny',
'moon',
'moon-night',
'dish',
'dish-1',
'food',
'chicken',
'fork-spoon',
'knife-fork',
'burger',
'tableware',
'sugar',
'dessert',
'ice-cream',
'hot-water',
'water-cup',
'coffee-cup',
'cold-drink',
'goblet',
'goblet-full',
'goblet-square',
'goblet-square-full',
'refrigerator',
'grape',
'watermelon',
'cherry',
'apple',
'pear',
'orange',
'coffee',
'ice-tea',
'ice-drink',
'milk-tea',
'potato-strips',
'lollipop',
'ice-cream-square',
'ice-cream-round',

                ],
                iconList: [
                    'attentionforbid',
                    'attentionforbidfill',
                    'attention',
                    'attentionfill',
                    'tag',
                    'tagfill',
                    'people',
                    'peoplefill',
                    'notice',
                    'noticefill',
                    'mobile',
                    'mobilefill',
                    'voice',
                    'voicefill',
                    'unlock',
                    'lock',
                    'home',
                    'homefill',
                    'delete',
                    'deletefill',
                    'notification',
                    'notificationfill',
                    'notificationforbidfill',
                    'like',
                    'likefill',
                    'comment',
                    'commentfill',
                    'camera',
                    'camerafill',
                    'warn',
                    'warnfill',
                    'time',
                    'timefill',
                    'location',
                    'locationfill',
                    'favor',
                    'favorfill',
                    'skin',
                    'skinfill',
                    'news',
                    'newsfill',
                    'record',
                    'recordfill',
                    'emoji',
                    'emojifill',
                    'message',
                    'messagefill',
                    'goods',
                    'goodsfill',
                    'crown',
                    'crownfill',
                    'move',
                    'add',
                    'hot',
                    'hotfill',
                    'service',
                    'servicefill',
                    'present',
                    'presentfill',
                    'pic',
                    'picfill',
                    'rank',
                    'rankfill',
                    'male',
                    'female',
                    'down',
                    'top',
                    'recharge',
                    'rechargefill',
                    'forward',
                    'forwardfill',
                    'info',
                    'infofill',
                    'redpacket',
                    'redpacket_fill',
                    'roundadd',
                    'roundaddfill',
                    'friendadd',
                    'friendaddfill',
                    'cart',
                    'cartfill',
                    'more',
                    'moreandroid',
                    'back',
                    'right',
                    'shop',
                    'shopfill',
                    'question',
                    'questionfill',
                    'roundclose',
                    'roundclosefill',
                    'roundcheck',
                    'roundcheckfill',
                    'global',
                    'mail',
                    'punch',
                    'exit',
                    'upload',
                    'read',
                    'file',
                    'link',
                    'full',
                    'group',
                    'friend',
                    'profile',
                    'addressbook',
                    'calendar',
                    'text',
                    'copy',
                    'share',
                    'wifi',
                    'vipcard',
                    'weibo',
                    'remind',
                    'refresh',
                    'filter',
                    'settings',
                    'scan',
                    'qrcode',
                    'cascades',
                    'apps',
                    'sort',
                    'searchlist',
                    'search',
                    'edit'
                ],
            }
        },
        computed: {
            list(){
                return this.iconList.filter((item) => {
                    return item.indexOf(this.keyword) !== -1;
                })
            },
            list2(){
                return this.iconList2.filter((item) => {
                    return item.indexOf(this.keyword) !== -1;
                })
            }
        },
        methods:{
            copyLink(text){  
                var copy = document.createElement("input");
                copy.setAttribute("value",'el-icon-lx-'+ text);
                document.body.appendChild(copy);
                copy.select();
                document.execCommand("copy");
                document.body.removeChild(copy);  
                //提示已复制
                this.$message.success("复制成功");  
                setTimeout( () => {
                    bus.$emit('icon-choose', 'el-icon-lx-'+text);
                }, 100) 

            },
            copyLink2(text){  
                var copy = document.createElement("input");
                copy.setAttribute("value",'el-icon-'+ text);
                document.body.appendChild(copy);
                copy.select();
                document.execCommand("copy");
                document.body.removeChild(copy);  
                this.$message.success("复制成功");  
                setTimeout( () => {
                    bus.$emit('icon-choose', 'el-icon-'+text);
                }, 100) 
                //提示已复制
                //
            },
        },
    }
</script>

<style scoped>
.example-p{
    height: 45px;
    display: flex;
    align-items: center;
}
.search-box{
    text-align: center;
    margin-top: 10px;
}
.search{
    width: 300px;
}
ul,li{
    list-style: none;
}
.icon-li{
    display: inline-block;
    padding: 10px;
    width: 100px;
    height: 40px;
}
.icon-li-content{
    display: flex;
    height: 100%;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    cursor: pointer;
}
.icon-li-content i{
    font-size: 36px;
    color: #606266;
}
.icon-li-content span{
    margin-top: 10px;
    color: #787878;
}
</style>